/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from "classnames";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";
import { currency } from "../../util/helper/currency";
import { fallBackTranslation } from "../../util/helper/fallBackTranslation";
import Popover from "../design-system/popover/Popover";
import Text from "../design-system/typography/Text";
import styles from "./product.module.scss";

function RenderPriceCorePopover() {
  const { t } = useTranslation(["product", "category"]);
  const fallbackT = fallBackTranslation("category", t);

  return (
    <div
      style={{ color: "#7f501a", width: 320, textAlign: "left" }}
    >

      <h5>

        <strong>
          {fallbackT("core_deposit_heading")}
        </strong>
      </h5>

      <Text size={6}>
        {fallbackT("core_deposit_description")}
      </Text>

      <br />

      <Text size={6}>
        {`${fallbackT("s_core_return_refund_1")},`}

        <Link href="/returns">{fallbackT("s_core_return_refund_2")}</Link>
      </Text>
    </div>
  );
}
function ProductCorePrice(props: any) {
  const {
    product = {}, corePrice = product.corePrice, corePriceSize = "big",
  } = props;

  const { t } = useTranslation("product");
  const router = useRouter();
  const { locale } = router;

  if (corePrice > 0) {
    return (
      <div
        className={classNames("paragraph color-grey d-flex align-items-center flex-wrap", {
          [styles.core_price_big]: corePriceSize === "big",
          [styles.core_price_small]: corePriceSize === "small",
          [styles.core_price_medium]: corePriceSize === "medium",
        })}
      >
        <i className="fa fa-thin fa-plus m-r-5" />
        <text className="color-dark-grey" style={{ fontSize: "1.1em" }}>
          {currency(corePrice, locale)}
          &nbsp;
        </text>

        <span className="m-r-5">{t("Core Deposit")}</span>

        <div style={{ width: 20 }}>

          <Popover
            component={<RenderPriceCorePopover />}
          >

            <i
              className="fa fa-info-circle pointer"
              style={{ fontSize: "1.3em" }}
            />
          </Popover>
        </div>
      </div>
    );
  }
  return <span />;
}

export default ProductCorePrice;
